import React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

const Test = styled(Paper)(({ theme }) => ({
  display: "inline-block",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  margin: theme.spacing(1),
}));

// const useStyles = makeStyles((theme) => ({
//   bubble: {
//     display: "inline-block",
//     backgroundColor: theme.palette.primary.main,
//     color: theme.palette.primary.contrastText,
//     borderRadius: theme.shape.borderRadius,
//     padding: theme.spacing(1),
//     margin: theme.spacing(1),
//   },
// }));

const BubbleComponent = ({ message }) => {
  return <Test>{message}</Test>;
};

export default BubbleComponent;
